import './Header.css';

const Header = () => {  
    const refresh = () => {
        window.location.reload();
    }

    return (
        <div className='appContainer'>
                <h1 className="appTitle" onClick={refresh}>iSphere IQ Timesheet App</h1>
        </div>
    )
};

export default Header;